<template>
    <div>
        <v-row justify="center" class="bg-color-teal-900">
            <v-col cols="0" sm="2"></v-col>
            <v-col cols="12" sm="8">
                <v-row>
                    <v-container>
                        <div class="body-text text-white mt-4">
                            <p class="text-h4 font-weight-light">Bonus Report
                            </p>
                        </div>
                        <div class="body-text text-white mt-4">
                            <br />
                            <span v-html="reportSubText">
                            </span>
                            <PleaseNote></PleaseNote>
                        </div>
                    </v-container>
                    <v-container>
                        <v-row class="my-2">
                            <v-col cols="12" sm="6">
                                <v-row>
                                    <v-select class="text-white" label="Select Quarter" v-model="selectedQuarter"
                                    :items="quarters" variant="outlined"
                                    aria-label="Select Quarter"></v-select>
                                </v-row>
                                <v-row class="gap-2" align="center">
                                    <v-btn @click="getReportData" color="white" variant="outlined"><LanguagePlaceholder default-text="Submit" /></v-btn>
                                    <v-btn class="mx-4" prepend-icon="mdi-download" @click="downloadFile" color="white" variant="outlined" aria-label="Download Report"><LanguagePlaceholder default-text="Download" /></v-btn>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-row>
            </v-col>
            <v-col cols="0" sm="2"></v-col>
        </v-row>
        <v-row justify="center" style="background-color: #ffffff;" class="pb-6">
            <v-container>
                <div>
                    <v-text-field v-model="searchString" label="Filter" prepend-inner-icon="mdi-filter-outline"
                        variant="outlined" hide-details single-line aria-label="Filter bonus data"></v-text-field> 
                    <v-data-table items-per-page="50" :headers="headers" :items="reportData"
                        item-key="id" :search="searchString" class="v-data-table"
                        role="table" aria-label="Distributor bonus dashboard data">
                    </v-data-table>                    
                </div>
            </v-container>
        </v-row>
    </div>
</template>

<script setup>
import { ref, onMounted, computed, watch } from 'vue'
import { useSystemStore } from '@/stores/system'
import { useReportsStore } from '@/stores/reports'
import LanguagePlaceholder from '@/components/LanguagePlaceholder.vue'
import { useExcelStore } from '@/stores/excel'
import { useUserStore } from '@/stores/user'
import PleaseNote from '@/components/PleaseNote.vue'


const systemStore = useSystemStore()
const reportsStore = useReportsStore()
const excelStore = useExcelStore()
const userStore = useUserStore()

const selectedQuarter = ref('')
const reportData = ref([])
const headers = ref([])
const quarters = ref([])
const selectedReport = ref({})
const searchString = ref('')
const reportSubText = ref('')
const userId = ref(0)

const downloadFile = () => {
    if (reportData.value.length === 0) {
        return
    }

    excelStore.generateInMemoryExcelDocumentV2(reportData.value, 'Bonus Report').catch(error => {
        console.log('Generate In Memory Excel Document', error)
    })
}

const getReportData = () => {

    if (selectedReport.value.Params.length > 0) {
        selectedReport.value.Params.forEach((p) => {
            if (p.Name === 'Quarter') {
                p.Value = selectedQuarter.value
            }
            else if (p.Name === 'UserId') {
                p.Value = userId.value
            }
        })
    }

    reportData.value = []

    reportsStore.getReportData(selectedReport.value, false, false).then(result => {
    if (result.success === true) {
        if (result.hasData) {
            const jsonObject = JSON.parse(result.reportData)
            const headings = Object.keys(jsonObject[0])
            headers.value = []

            headings.forEach(element => {
                headers.value.push({
                    title: `${reportsStore.formatHeader(element)}`,
                    value: `${element}`,
                    headerProps: { class: 'header-style' },
                    sortable: true
                });
            });

            reportData.value = jsonObject;
        }            
    }
  }).catch(error => {
      console.log(`get data`, error)
  })
}

const getBonusReportTemplate = () => {
    reportsStore.getReports(':BonusReport:').then(result => {
    if (result.success === true) {
        if (result.hasData) {
          selectedReport.value = JSON.parse(result.reportData)[0];
          if (selectedReport.value.Params.length > 0) {
            selectedReport.value.Params = JSON.parse(selectedReport.value.Params) 
          }
          reportSubText.value = selectedReport.value.ReportSubText
       }
    }
  }).catch(error => {
      console.log(`get title`, error)
  })
}

onMounted(() => {
    systemStore.getQuarters().then(result => {
        if (result.success) {
            quarters.value = result.quarters
                .filter(q => q.currentQuarters === true)
                .map(q => q.quarter)
        }
    }).catch(error => {
        console.log('recalculateLocalValue', error)
    })

    userStore.getUserId().then(result => {
        userId.value = result.responseData;    
    }).catch(error => {
        console.log('getUserId', error)
    })

    getBonusReportTemplate()
})

</script>


<style>
.header-style {

/* background-color: #012a4b; */
background-color: #012a4b;
color: white;
}

.v-data-table tbody tr:nth-child(even) {
  background-color: #e0e6ec;
  color: #202520;
}

.v-data-table tbody tr:nth-child(odd) {
  background-color: whitesmoke;
  color: #202520;
}
</style>
